import { useId } from 'react'
import './Input.css'

export function Input({ label, hint, error, id, style, ...rest }) {
  const autoId = useId()
  const iid = id || autoId
  const messageId = iid + '-msg'
  const message = error || hint

  return (
    <div className="u-field" style={style}>
      {label && <label htmlFor={iid}>{label}</label>}
      <input
        id={iid}
        className={'u-input' + (error ? ' u-input--error' : '')}
        aria-invalid={error ? true : undefined}
        aria-describedby={message ? messageId : undefined}
        {...rest}
      />
      {message ? (
        <span id={messageId} className={error ? 'u-err' : 'u-hint'}>
          {message}
        </span>
      ) : null}
    </div>
  )
}

export default Input
